import { Component, OnInit } from '@angular/core';
import { Chart, ChartModule } from "angular-highcharts";
import { RapportService } from '../../../services/rapport-service/rapport.service';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle, MatCardSubtitle } from "@angular/material/card";
import { MatButton } from "@angular/material/button";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";

@Component({
  selector: 'app-rapport-chart',
  standalone: true,
  imports: [
    ChartModule,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    MatCardSubtitle,
    MatButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger
  ],
  templateUrl: './rapport-chart.component.html',
  styleUrls: ['./rapport-chart.component.scss']
})
export class RapportChartComponent implements OnInit {

  duration: string[] = ['Jour', 'Semaine', 'Mois', 'Année'];
  selectedDuration: string = 'jour';

  chartTypes: ('area' | 'bar' | 'column' | 'spline')[] = ['area', 'bar', 'column', 'spline'];
  selectedChartTypes: 'area' | 'bar' | 'column' | 'spline' = this.chartTypes[0];

  lineChart: Chart;
  pieChart: Chart;

  constructor(private rapportService: RapportService) { }

  ngOnInit(): void {
    this.loadRapportData(this.selectedDuration);  // Charger les données dès le début
  }

  loadRapportData(duration: string): void {
    console.log(`🔄 Chargement des données pour la durée : ${duration}`);

    this.rapportService.getChartData(duration).subscribe(data => {
      console.log('✅ Données reçues du backend:', data);

      const dateCountMap: { [key: string]: number } = {};
      const interpretationData: { [key: string]: number } = {};

      // Traitement des données pour les deux graphiques
      data.forEach(item => {
        if (item.creationDate && typeof item.count === 'number') {
          const formattedDate = new Date(item.creationDate).toLocaleDateString();
          dateCountMap[formattedDate] = (dateCountMap[formattedDate] || 0) + item.count;

          // Si vous avez un champ "interpretation" dans les données, vous pouvez aussi le compter
          const interpretation = item.interpretation;
          interpretationData[interpretation] = (interpretationData[interpretation] || 0) + 1;
        } else {
          console.warn("⚠️ Donnée ignorée (problème de format) :", item);
        }
      });

      // Mise à jour du graphique linéaire (nombre de rapports créés)
      const dates = Object.keys(dateCountMap);
      const counts = Object.values(dateCountMap);

      if (this.lineChart) {
        this.lineChart.ref?.update({
          chart: {
            type: this.selectedChartTypes
          },
          series: [{
            type: this.selectedChartTypes,
            name: 'Nombre de rapports',
            data: counts
          }]
        });
      } else {
        this.lineChart = new Chart({
          chart: {
            type: this.selectedChartTypes
          },
          title: {
            text: `Nombre de rapports créés (${this.selectedDuration})`
          },
          credits: {
            enabled: false
          },
          xAxis: {
            categories: dates,
            title: {
              text: 'Dates'
            }
          },
          yAxis: {
            title: {
              text: 'Nombre de rapports'
            },
            min: 0,
            tickInterval: 1,
            labels: {
              formatter: function () {
                return String(this.value);
              }
            }
          },
          series: [{
            type: this.selectedChartTypes,
            name: 'Nombre de rapports',
            data: counts
          }]
        });
      }

      // Mise à jour du graphique pie pour les interprétations
      this.updatePieChart(interpretationData);

    }, error => {
      console.error('Erreur lors de la récupération des données du backend:', error);
    });
  }

  updatePieChart(interpretationData: { [key: string]: number }): void {
    const total = Object.values(interpretationData).reduce((acc, value) => acc + value, 0);
    
    const pieData = Object.keys(interpretationData).map(interpretation => ({
      name: interpretation,
      y: total > 0 ? (interpretationData[interpretation] / total) * 100 : 0
    }));

    if (this.pieChart) {
      this.pieChart.ref?.update({
        series: [{
          type: 'pie',
          data: pieData
        }]
      });
    } else {
      this.pieChart = new Chart({
        chart: {
          type: 'pie',
          plotShadow: false,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Répartition des rapports par interprétation'
        },
        series: [{
          type: 'pie',
          data: pieData
        }]
      });
    }
  }

  handleChartType(type: 'area' | 'bar' | 'column' | 'spline'): void {
    this.selectedChartTypes = type;
    this.loadRapportData(this.selectedDuration);
  }

  handleDuration(duration: string): void {
    this.selectedDuration = duration;
    this.loadRapportData(this.selectedDuration);
  }
}
